import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';
import { URLS } from 'config';
import { useCallback, useContext, type MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import { LEAD_SLIDE_UP_MODAL_ID } from '../LeadSlideUpModal/constants';

export interface MobileHeaderHook {
  onClick: () => void;
  openSlideUp: (event: MouseEvent<HTMLButtonElement>) => void;
}

export default function useMobileHeader(): MobileHeaderHook {
  const { showModal } = useContext(ModalsWrapperContext);
  const { length, goBack, push } = useHistory();

  const openSlideUp = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      showModal(LEAD_SLIDE_UP_MODAL_ID);
    },
    [showModal],
  );

  const onClick = useCallback(() => {
    if (length === 0) {
      push(URLS.leads);
      return;
    }
    const previousURL = document.referrer;
    if (previousURL.includes('leads')) {
      goBack();
      return;
    }
    push(URLS.leads);
  }, [length, goBack, push]);

  return {
    onClick,
    openSlideUp,
  };
}
